import React from 'react';
import {API_BASE} from "../../hooks/api";

const BlogEntry = ({ entry }) => {
    const link = `/blog-details/${entry.id}`;

    return (
        <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
            <div className="video-blog-item" style={{height: '100%'}}>
                <div className="video-blog-thumb">
                    <a href={link}>
                        <img
                            style={{width: '100%', aspectRatio: '16 / 9', objectFit: 'cover'}}
                            src={`${API_BASE}/blog/media?size=medium&id=${entry.featured_media}`}
                            alt=""
                        />
                    </a>
                </div>
                <div className="video-blog-content">
                    <div className="video-blog-meta">
                        <ul>
                            <li><i className="far fa-clock" /> {new Date(entry.date).toLocaleDateString()}</li>
                            {entry.categories?.length > 0 && (
                                <li><i className="far fa-folder" /> {entry.categories[0].name}</li>
                            )}
                        </ul>
                    </div>
                    <h4 className="title">
                        <a href={link}><span dangerouslySetInnerHTML={{__html: entry.title.rendered}}/></a>
                    </h4>
                    <div style={{
                        display: '-webkit-box',
                        WebkitLineClamp: '3',
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        marginBottom: '15px',
                    }}>
                        <div dangerouslySetInnerHTML={{__html: entry.excerpt.rendered}}/>
                    </div>
                    <a href={link} className="read-more">
                        Read More <i className="fas fa-caret-right" />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default BlogEntry;
